import { PilotApiValidationResult } from '../../../types';

// pilot-api fails the scan unless the average blurScore metric over all photos is above the threshold,
// so every image photo needs this result, empty and unvalidated ones included.
export const passingBlurScore = (threshold: number): PilotApiValidationResult => [true, threshold + 1];
